import React from 'react';

import { LABEL } from './brandTheme';

// "Do you have a VA.gov account?" on every public intake (restructure
// 2026-09-24). Same segmented look as /reach-out's veteran question, on the
// fixed dark brand theme. Values match the API: 'yes' | 'no' | 'unsure'.
export const VA_GOV_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unsure', label: "I don't know" },
];

const VaGovAccountQuestion = ({
  value,
  onChange,
  label = 'Do you have a VA.gov account?',
  required = true,
}) => (
  <div role="radiogroup" aria-label={label}>
    <div className={LABEL}>
      {label}
      {required ? <span className="text-rose-400"> *</span> : null}
    </div>
    <div className="grid grid-cols-3 gap-2">
      {VA_GOV_OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => onChange(o.value)}
          className={`h-10 whitespace-nowrap rounded-md px-1 text-sm font-medium transition-colors ${
            value === o.value
              ? 'bg-white text-black'
              : 'bg-black text-neutral-400 hover:text-white'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  </div>
);

export default VaGovAccountQuestion;
